var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUsers = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M16 19.02q1.86 0 4.08.54 2.52.63 4.08 1.68 1.86 1.23 1.86 2.76v2.52H5.98V24q0-1.53 1.86-2.76 1.56-1.05 4.08-1.68 2.22-.54 4.08-.54m0-2.52q-1.35 0-2.49-.675a5.1 5.1 0 0 1-1.815-1.815 4.8 4.8 0 0 1-.675-2.49q0-1.35.675-2.52a5 5 0 0 1 1.815-1.845Q14.65 6.48 16 6.48t2.49.675A5 5 0 0 1 20.305 9q.675 1.17.675 2.52t-.675 2.49a5.1 5.1 0 0 1-1.815 1.815q-1.14.675-2.49.675"
})));
export default SvgUsers;